import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ArrowDown } from 'lucide-react';
import { useTenant } from '../../../context/TenantContext';
import { parseEm } from '../inlineEm';

const DEFAULTS = {
  headline: 'Spring intake closes 12 May. Apply now.',
  body: 'applications take ~10 minutes · hear back within 5 working days',
  buttonText: 'Apply now',
};

export const UtilityCTASection: React.FC = () => {
  const { tenant } = useTenant();
  const cta = tenant?.branding.marketing?.cta ?? {};
  const headline = cta.headline || DEFAULTS.headline;
  const body = cta.body || DEFAULTS.body;
  const buttonText = cta.buttonText || DEFAULTS.buttonText;

  return (
    <section id="cta" className="util-closer relative overflow-hidden bg-[var(--util-ink)] text-[var(--util-paper)] py-20">
      <div
        className="absolute inset-0 pointer-events-none opacity-50"
        style={{
          backgroundImage: 'linear-gradient(to right, rgba(255,255,255,0.04) 1px, transparent 1px)',
          backgroundSize: 'calc(100%/12) 100%',
        }}
      />
      <div className="relative max-w-[1320px] mx-auto px-6 grid md:grid-cols-[1fr_auto] gap-10 items-end">
        <div>
          <h2 className="font-util-sans text-4xl md:text-5xl lg:text-[60px] font-semibold tracking-[-0.03em] leading-[1.0] max-w-[16ch] text-balance">
            {renderWithAccent(headline)}
          </h2>
          <div className="mt-4 font-util-mono text-[12px] tracking-[0.04em] text-[var(--util-mute-2)] opacity-70">
            // {body}
          </div>
        </div>
        <div className="flex gap-3 self-start md:self-end">
          <Link
            to="/login"
            className="inline-flex items-center gap-2 px-5 py-3.5 text-sm font-medium border border-white/20 rounded-md hover:bg-white/5 transition-colors"
          >
            <ArrowDown className="h-4 w-4" />
            Syllabus
          </Link>
          <Link
            to="/courses"
            className="util-btn-primary group inline-flex items-center gap-2 px-5 py-3.5 text-sm font-semibold rounded-md whitespace-nowrap"
          >
            {buttonText}
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </section>
  );
};

/** `*word*` markdown coloured in the accent. */
const renderWithAccent = (text: string) =>
  parseEm(text, (children, key) => (
    <span key={key} className="text-[var(--util-accent)]">{children}</span>
  ));
